window.addEventListener('scroll', () => {
  if(window.pageYOffset > 0.3*document.body.scrollHeight) {
      document.querySelector('.page-btn_up').classList.add('active');
  } else {
      document.querySelector('.page-btn_up').classList.remove('active');
  };
  
  if(window.pageYOffset > 10) {
      document.querySelector('.header').classList.add('header--fixed');
  } else {
      document.querySelector('.header').classList.remove('header--fixed');
  };
});